import React, { useState, useEffect } from "react";
import { Container, InputField } from "@common";
import DataTableReact from "@common/datatable/DataTableReact.jsx";
import apiService from "services/apiService";
import { Dots } from "../../assets/svg.js";
import { Menu, MenuItem } from "@mui/material";
import CustomModal from "@common/CustomModal/CustomModal.js";
import { Button, Modal, ModalBody, ModalFooter } from "reactstrap";
import { FaPlus } from "react-icons/fa6";
import { toast } from "react-toastify";
import { Formik, Field, Form } from "formik";
import * as Yup from "yup";
function Region() {
  const [regions, setRegions] = useState([]);
  const [editableRegion, setEditableRegion] = useState(null);
  const [openRowId, setOpenRowId] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteRegionId, setDeleteRegionId] = useState("");
  const [openForm, setOpenForm] = useState(false);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);

  const handleClick = (event, rowId) => {
    setAnchorEl(event.currentTarget);
    setOpenRowId(rowId);
  };
  const handleCloseTableModal = () => {
    setAnchorEl(null);
    setOpenRowId(null);
  };

  function handleDeleteRegion(id) {
    apiService
      .delete(`region/${id}`)
      .then((res) => {
        toast.success(res.message);
        fetchRegions();
        setIsModalOpen(false);
        setDeleteRegionId("");
      })
      .catch((err) => {
        toast.error(err.response.data.message);
        console.log("Error Deleting region", err);
      });
  }

  function handleCreateRegion(values) {
    apiService
      .post("region", { name: values.regionName })
      .then((res) => {
        toast.success(res.message);
        fetchRegions();
      })
      .catch((err) => {
        toast.error(err.response.data.message);
        console.log("Error creating region", err);
      });
  }

  function handleUpdateRegion(values) {
    apiService
      .put(`region/${editableRegion?.id}`, { name: values.regionName })
      .then((res) => {
        toast.success(res.message);

        fetchRegions();
        setEditableRegion(null);
        setIsEdit(false);
      })
      .catch((err) => {
        toast.error(err.response.data.message);
        console.log("Error Updating region", err);
      });
  }

  function handleRegionSubmit(values, { resetForm }) {

    document.body.style.overflow = "auto";
    if (isEdit) {
      document.body.style.overflow = "auto";
      handleUpdateRegion(values);
    } else {
      document.body.style.overflow = "auto";
      handleCreateRegion(values);
    }
    setOpenForm(false);
    resetForm();
  }

  const columns = [
    {
      id: "Region Name",
      header: "Region Name",

      accessorFn: (row) => {
        return (
          <span className="line-clamp-1 self-stretch overflow-hidden text-[#0A0D14] text-ellipsis font-inter text-sm font-normal leading-[20px] tracking-[-0.084px]">
            {row?.regionName}
          </span>
        );
      },
    },
  ];
  const renderRowActions = ({ row, table }) => {
    const isOpen = openRowId === row.index;

    return (
      <>
        <div className="flex gap-3">
          <Dots
            className="action-icon cursor-pointer"
            onClick={(e) => handleClick(e, row?.index)}
          />
        </div>

        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={isOpen}
          onClose={handleCloseTableModal}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
          sx={{
            boxShadow: "none", // Removing box shadow
          }}
        >
          <MenuItem
            sx={{
              fontSize: "18px",
              padding: "1px 24px",
              minWidth: "150px",
              borderRadius: "16px",
              "&:hover": {
                backgroundColor: "#FFF",
              },
            }}
          >
            <div
              className="flex justify-between w-[100%] "
              onClick={() => {
                setAnchorEl(null);
                setOpenRowId(false);
              }}
            >
              <p
                className="self-center m-1 "
                onClick={() => {
                  setIsEdit(true);
                  setOpenForm(true);
                  setEditableRegion({
                    name: row?.original?.regionName,
                    id: row?.original?.id,
                  });
                }}
              >
                Edit
              </p>
            </div>
          </MenuItem>
          <MenuItem
            sx={{
              fontSize: "18px",
              padding: "1px 24px",
              minWidth: "150px",
              borderRadius: "16px",
              "&:hover": {
                backgroundColor: "#FFF",
              },
            }}
          >
            <div
              className="flex justify-between w-[100%] "
              onClick={() => {
                setAnchorEl(null);
                setOpenRowId(false);
              }}
            >
              <p
                className="self-center m-1 "
                onClick={() => {
                  setIsModalOpen(true);
                  setDeleteRegionId(row?.original?.id);
                }}
              >
                Delete
              </p>
            </div>
          </MenuItem>
        </Menu>
      </>
    );
  };

  const handleRenderRowActions = ({ row, table }) =>
    renderRowActions({ row, table });

  const fetchRegions = async () => {
    try {
      const { data } = await apiService.get(
        `region?is_pagination=true&per_page=${rowsPerPage}&page=${page}`
      );

      setTotalRows(data?.total);
      setRegions(
        data?.data?.map(({ name, _id, ...rest }) => ({
          regionName: name,
          id: _id,
          ...rest,
        }))
      );
    } catch (e) {
      console.log("Error fetching regions:", e);
    }
  };


  useEffect(() => {

    if (openForm) {
      // Disable body scroll when modal is open
      document.body.style.overflow = "hidden";
    } else {
      // Re-enable body scroll when modal is closed

    }

    // Cleanup function to reset overflow when the component unmounts
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [openForm]);

  useEffect(() => {
    fetchRegions(page, rowsPerPage);
  }, [page, rowsPerPage]);

  const initialValues = {
    regionName: editableRegion?.name ? editableRegion?.name : "",
  };
  const validationSchema = Yup.object({
    regionName: Yup.string().required("Region Name is required"),
  });
  return (
    <Container>
      <div className="flex gap-2 mb-4">
        <h1>Region</h1>
        <div
          className="flex items-center justify-center w-12 h-12 bg-gray-100 rounded-full transition-transform transform duration-200 
                hover:shadow-lg hover:scale-105 active:scale-95 cursor-pointer"
          onClick={() => setOpenForm(true)}
        >
          <FaPlus className="text-green-500 text-3xl" />
        </div>
      </div>
      <CustomModal
        isOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        title={"Delete Region"}
        bodyText={"Are you want to Delete this region?"}
        buttonText={"Delete"}
        onClick={() => handleDeleteRegion(deleteRegionId)}
      />
      {openForm && <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
        <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6 relative">
          <Formik
            initialValues={initialValues}
            enableReinitialize={true}
            validationSchema={validationSchema}
            onSubmit={handleRegionSubmit}
          >
            {({ values, errors, touched, setFieldValue, handleChange }) => (
              <ModalBody>
                <Form>
                  <div className="">
                    <div>
                      <InputField
                        isRequiredClass="text-[#2D9F75]"
                        label="Region Name"
                        name="regionName"
                        isRequired={true}
                        height="h-[40px]"
                        value={values.regionName}
                        onChange={(e) => handleChange(e)}
                      />
                      {touched.regionName && errors.regionName && (
                        <div className="text-red-500 text-sm mt-1">
                          {errors.regionName}
                        </div>
                      )}
                    </div>
                      <div className="d-flex justify-content-end self-end gap-2 mt-4">
                        <Button color="success" type="submit">
                          {!isEdit ? "Submit" : "Update"}
                        </Button>
                        {/* {isEdit && ( */}
                          <Button
                            color="danger"
                            type="submit"
                            onClick={() => {
                              setIsEdit(false);
                              setOpenForm(false);
                              setEditableRegion(null);
                            }}
                          >
                            Cancel
                          </Button>
                        {/* )} */}
                      </div>
                  </div>
                </Form>
              </ModalBody>
            )}
          </Formik>
        </div>
      </div>}

      <DataTableReact
        data={regions}
        columns={columns}
        setPage={setPage}
        page={page}
        setRowsPerPage={setRowsPerPage}
        rowsPerPage={rowsPerPage}
        totalRows={totalRows}
        renderRowActions={handleRenderRowActions}
        shouldShowActions={true}
      />
    </Container>
  );
}

export default Region;
